import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";

const KitDetails = ({ clinician, productName, symptoms, DOR, allergies, medication, labNameAndReqId, sampleCollectedDate }) => {
  return (
    <>
      <Row align="start">
        <Col>
          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Clinician
            </Form.Label>
            <Col sm={8}>
              <Form.Control aria-label="Clinician" aria-describedby="basic-addon1" defaultValue={clinician} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Product Name
            </Form.Label>
            <Col sm={8}>
              <Form.Control aria-label="Clinician" aria-describedby="basic-addon1" defaultValue={productName} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Symptoms
            </Form.Label>
            <Col sm={8}>
              <Form.Control as={"textArea"} aria-label="symptoms" aria-describedby="basic-addon1" placeholder={symptoms} readOnly />
            </Col>
          </Form.Group>
          <Form.Group className="FormCol" as={Row} controlId="labNameAndReqId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Lab Name & Req Id
            </Form.Label>
            <Col sm={8}>
              <Form.Control aria-label="labNameAndReqId" aria-describedby="basic-addon1" defaultValue={labNameAndReqId} readOnly />
            </Col>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Date of Registration
            </Form.Label>
            <Col sm={8}>
              <Form.Control placeholder="Date of Registration" aria-label="Date of Registration" aria-describedby="basic-addon1" defaultValue={DOR} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Sample Collected on
            </Form.Label>
            <Col sm={8}>
              <Form.Control aria-label="sampleCollectedOn" aria-describedby="basic-addon1" defaultValue={sampleCollectedDate} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Medication
            </Form.Label>
            <Col sm={8}>
              <Form.Control as={"textArea"} aria-label="Clinician" aria-describedby="basic-addon1" placeholder={medication} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Allergies
            </Form.Label>
            <Col sm={8}>
              <Form.Control as={"textArea"} aria-label="Clinician" aria-describedby="basic-addon1" placeholder={allergies} readOnly />
            </Col>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default KitDetails;
